import { gql } from "@apollo/client";

export const QUERY_FORM3457E_VERSION = gql`
  query studentForm3457E(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3457E(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      studentDob
      parent1
      parent2
      meetingDateAndTime
      meetingLocation
      eligibility
      eligibilityCategory
      requiresSpecialEducationChange
      requiresSeparateEducationalSetting
      willReceiveSpecialEducation
      willReceiveGoalsTransitions
      willReceiveFunctionalBehavioral
      disciplinaryCodeViolation
      graduationRecommended
      other
      otherDescription
      waiveTenDaysRequirement
      documentContactName
      documentContactTitle
      documentContactPhone
      signatureName
      signatureTitle
      formAction
      formStatus
    }
  }
`;
